// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"web_src_layouts_BaseLayout_tsx":"31d6cfe0d16ae931b73c","web_src_pages_home_index_tsx-web_src_assets_imgs_android_png-web_src_assets_imgs_iphone_png-w-89d53d":"ba2f4873542af02b1a15"}[chunkId] + ".css";
};